// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"145":"648d785b","342":"c01bf1ca"}[chunkId] + ".css";
};